module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-button",
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f514108e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/text-button.vue
// module id = 892
// module chunks = 34